var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "red-packet-container" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "裂变活动列表", name: "list" } },
            [
              _vm.activeName === "list"
                ? _c("fission-table-pane", {
                    on: {
                      edit: _vm.handleEdit,
                      create: _vm.handleToCreate,
                      copy: _vm.handleCopyToCreate,
                      statistics: _vm.handleStatistics,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeName === "create"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "创建裂变活动", name: "create" } },
                [
                  _vm.activeName === "create"
                    ? _c("fission-create-pane", {
                        attrs: { id: _vm.fissionId },
                        on: { toTable: _vm.handleToTable },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeName === "update"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "更新裂变活动", name: "update" } },
                [
                  _vm.fissionId !== "" && _vm.activeName === "update"
                    ? _c("fission-update-pane", {
                        attrs: { id: _vm.fissionId },
                        on: { toTable: _vm.handleToTable },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeName === "statistics"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "裂变活动统计", name: "statistics" } },
                [
                  _vm.activeName === "statistics"
                    ? _c("fission-statistics-pane", {
                        attrs: {
                          "activity-id": _vm.fissionId,
                          "activity-name": _vm.fissionActivityName,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "黄牛白名单", name: "whitelist" } },
            [
              _vm.activeName === "whitelist"
                ? _c("fission-scalper-whitelist-pane")
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }